// packages/core/src/ifid/index.ts
export { generateIfid, validateIfid, normalizeIfid } from './ifid.js';
